import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    servDescriptionId: '',
    servDescriptionDataPath: '',
    servDescriptionDescription: '',
    servDescriptionProgress: 0,
    servDescriptionTotal: 0,
    servDescriptionStatus: 'Init',
    servDescriptionCreatedTs: '',
}


export const servDescriptionSlice = createSlice({
    name: 'servDescriptionBatch',
    initialState,
    reducers: {
        addServDescriptionBatch: (state, action) => {
            if (action.payload && action.payload.id) {
                const res = action.payload;
                state.servDescriptionId = res.id;
                state.servDescriptionDataPath = res.dataPath;
                state.servDescriptionDescription = res.description;
                state.servDescriptionProgress = res.progress;
                state.servDescriptionTotal = res.total;
                state.servDescriptionStatus = res.status;
                state.servDescriptionCreatedTs = res.createdTs;

            }
        },
        resetServDescription: () => initialState,
    }
})


export const { addServDescriptionBatch, resetServDescription } = servDescriptionSlice.actions;

export default servDescriptionSlice.reducer;